export const FETCH_LOGGED_IN_USER = 'FETCH_LOGGED_IN_USER';
export const FETCH_INITIAL_DATA = 'FETCH_INITIAL_DATA';
export const FETCH_TESTING_OPTIONS = 'FETCH_TESTING_OPTIONS';
export const FETCH_AUTH_EMAIL = 'FETCH_AUTH_EMAIL';
export const FETCH_REMOTE_CONFIG = 'FETCH_REMOTE_CONFIG';
export const FETCH_RECENT_SEARCHES = 'FETCH_RECENT_SEARCHES';
